/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionDisputeDecision } from './CompetitionDisputeDecision';
import {
    CompetitionDisputeDecisionFromJSON,
    CompetitionDisputeDecisionFromJSONTyped,
    CompetitionDisputeDecisionToJSON,
    CompetitionDisputeDecisionToJSONTyped,
} from './CompetitionDisputeDecision';

/**
 * 
 * @export
 * @interface CompetitionDisputeResolution
 */
export interface CompetitionDisputeResolution {
    /**
     * 
     * @type {string}
     * @memberof CompetitionDisputeResolution
     */
    resolvedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionDisputeResolution
     */
    resolvedAt?: number;
    /**
     * 
     * @type {CompetitionDisputeDecision}
     * @memberof CompetitionDisputeResolution
     */
    decision?: CompetitionDisputeDecision;
    /**
     * 
     * @type {string}
     * @memberof CompetitionDisputeResolution
     */
    notes?: string;
}



/**
 * Check if a given object implements the CompetitionDisputeResolution interface.
 */
export function instanceOfCompetitionDisputeResolution(value: object): value is CompetitionDisputeResolution {
    return true;
}

export function CompetitionDisputeResolutionFromJSON(json: any): CompetitionDisputeResolution {
    return CompetitionDisputeResolutionFromJSONTyped(json, false);
}

export function CompetitionDisputeResolutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionDisputeResolution {
    if (json == null) {
        return json;
    }
    return {
        
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : json['resolvedAt'],
        'decision': json['decision'] == null ? undefined : CompetitionDisputeDecisionFromJSON(json['decision']),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CompetitionDisputeResolutionToJSON(json: any): CompetitionDisputeResolution {
    return CompetitionDisputeResolutionToJSONTyped(json, false);
}

export function CompetitionDisputeResolutionToJSONTyped(value?: CompetitionDisputeResolution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolvedBy': value['resolvedBy'],
        'resolvedAt': value['resolvedAt'],
        'decision': CompetitionDisputeDecisionToJSON(value['decision']),
        'notes': value['notes'],
    };
}

